module.exports = __webpack_public_path__ + "img/长腿瘦身--精准美体.ca0460c4.png";